import type { RouteRecordRaw } from 'vue-router'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import { SHOPPING_ASSISTANT, SHOPPING_ASSISTANT_NEW } from './routes.constants'

export default (): RouteRecordRaw[] => {
  const experiments = useExperiments()
  const isShoppingAssistantEnabled =
    experiments['experiment.aiShoppingAssistant'] === 'enabled'

  return [
    {
      path: 'assistant/new',
      name: SHOPPING_ASSISTANT_NEW,
      component: () =>
        import('~/scopes/shopping-assistant/pages/ShoppingAssistant.vue'),
      meta: {
        layout: false,
        owners: ['bot-group-ai-shopping-assistant-front'],
        routeExists: isShoppingAssistantEnabled,
      },
    },
    {
      path: 'assistant/:chatId?',
      name: SHOPPING_ASSISTANT,
      component: () =>
        import('~/scopes/shopping-assistant/pages/ShoppingAssistant.vue'),
      meta: {
        layout: false,
        owners: ['bot-group-ai-shopping-assistant-front'],
        routeExists: isShoppingAssistantEnabled,
      },
    },
  ]
}
